"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        root: {},
        input: {
            background: 'white',
            color: 'black',
            justifyContent: 'space-between',
            maxWidth: 550,
            width: 350,
            marginRight: 8,
            height: 36,
            padding: '10px 15px',
            border: 1,
            borderRadius: 4,
            boxShadow: 'inset 0 1px 3px 0 rgb(0 0 0 / 50%)',
            fontFamily: 'Montserrat',
            fontSize: 14
        },
        searchButton: {
            display: 'inline-block',
            padding: '8px 22px',
            textAlign: 'center',
            verticalAlign: 'middle',
            height: 36,
            minWidth: 80,
            outline: 'none',
            MozAppearance: 'none',
            fontFamily: 'Montserrat!important',
            fontSize: 16,
            lineHeight: 1,
            boxSizing: 'border-box',
            borderRadius: 5,
            border: '1px solid',
            backgroundColor: '#fff',
            color: function (_a) {
                var color = _a.color;
                return color;
            }
        },
        formControl: {
            marginRight: 8,
            width: 250
        },
        selectIcon: {
            color: 'white'
        },
        selectInput: {
            borderRadius: 6,
            border: '0 solid',
            backgroundColor: 'rgba(0,0,0,.25)',
            color: 'white',
            fontFamily: 'Montserrat',
            fontSize: 16,
            textTransform: 'uppercase',
            display: 'inline-block',
            padding: '8px 22px',
            verticalAlign: 'middle',
            height: 36,
            minWidth: 120,
            boxSizing: 'border-box',
            '&:focus': {
                backgroundColor: 'rgba(0,0,0,.35)',
                borderRadius: 6
            }
        }
    });
});
var Search = function (_a) {
    var _b;
    var searchType = _a.searchType, searchTerm = _a.searchTerm, items = _a.items, onSubmit = _a.onSubmit, color = _a.color, setActiveSearchType = _a.setActiveSearchType, setSearchTerm = _a.setSearchTerm;
    var activeSearchType = (_b = items.find(function (i) { return searchType === i.searchType; })) !== null && _b !== void 0 ? _b : items[0];
    var classes = useStyles({ color: color });
    var handleTermChange = function (e) {
        var searchTerm = e.target.value;
        setSearchTerm(searchTerm);
    };
    var handleTypeChange = function (e) {
        setActiveSearchType(items.find(function (i) { return i.searchType === e.target.value; }));
    };
    var handleSubmit = function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        onSubmit({ searchTerm: searchTerm, searchType: activeSearchType === null || activeSearchType === void 0 ? void 0 : activeSearchType.searchType });
    };
    return (react_1.default.createElement("form", { "aria-label": 'Search Form', className: classes.root, onSubmit: handleSubmit },
        react_1.default.createElement(core_1.FormControl, { classes: { root: classes.formControl } },
            react_1.default.createElement(core_1.Select, { disableUnderline: true, classes: { root: classes.selectInput, icon: classes.selectIcon }, labelId: 'demo-simple-select-disabled-label', id: 'demo-simple-select-disabled', value: activeSearchType === null || activeSearchType === void 0 ? void 0 : activeSearchType.searchType, label: 'Age', onChange: handleTypeChange, MenuProps: {
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                    },
                    getContentAnchorEl: null
                } }, items.map(function (i) { return (react_1.default.createElement(core_1.MenuItem, { value: i.searchType, key: i.searchType }, i.searchLabel)); }))),
        react_1.default.createElement("input", { type: 'text', "aria-label": 'Search Term Input', placeholder: activeSearchType === null || activeSearchType === void 0 ? void 0 : activeSearchType.placeholder, onChange: handleTermChange, className: classes.input, value: searchTerm !== null && searchTerm !== void 0 ? searchTerm : '' }),
        react_1.default.createElement(core_1.ButtonBase, { type: 'submit', className: classes.searchButton, "aria-label": 'Search Button' }, "SEARCH")));
};
exports.Search = Search;
//# sourceMappingURL=Search.js.map